import { ADD_CONTACTS_SUCCESS } from 'modules/contactLists/actionTypes';
import * as types from 'modules/contactMembers/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<Array<import("../types").ContactMember>>} ContactMembersDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<Array<import('../types').ContactMember>>} */
const contactMembersAdapter = createEntityAdapter({ selectId: ({ id }) => id });

/**
 * @param {ContactMembersDataEntity} state
 * @param {import('modules/contactLists/types').AddContactsSuccessAction} action
 * @returns {ContactMembersDataEntity}
 */
const addOne = (state, { payload }) => contactMembersAdapter.addOne(state, payload);

/**
 * @param {ContactMembersDataEntity} state
 * @param {import('../types').UpdateContactMemberSuccessAction} action
 * @returns {ContactMembersDataEntity}
 */
const updateOne = (state, { payload }) => contactMembersAdapter.updateOne(state, payload);

/**
 * @param {ContactMembersDataEntity} state
 * @param {import('../types').DeleteContactMemberSuccessAction} action
 * @returns {ContactMembersDataEntity}
 */
const deleteOne = (state, { payload }) => contactMembersAdapter.removeOne(state, payload.contactMemberId);

/**
 * @param {ContactMembersDataEntity} state
 * @param {import('modules/global/generic.types').PageContent<Array<import('../types').ContactMember>>} action
 * @returns {ContactMembersDataEntity}
 */
const setAllFromPage = (state, { payload: { content } }) => contactMembersAdapter.setAll(state, content);

export default createReducer(contactMembersAdapter.getInitialState(), {
  [types.FETCH_CONTACT_MEMBERS_SUCCESS]: setAllFromPage,
  [types.DELETE_CONTACT_MEMBERS_SUCCESS]: deleteOne,
  [types.UPDATE_CONTACT_MEMBER_SUCCESS]: updateOne,
  [ADD_CONTACTS_SUCCESS]: addOne,
});
